import { Box, Paper, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";
import { useId } from "react";

interface PaneProps {
  readonly label: string;
  readonly children: ReactNode;
}

const Pane: FC<PaneProps> = ({ label, children }) => {
  const labelId = useId();
  return (
    <Paper
      component="section"
      aria-labelledby={labelId}
      elevation={0}
      sx={{ p: 3, border: "1px solid rgba(0,0,0,0.08)", borderRadius: 2, minWidth: 0 }}
    >
      <Typography
        id={labelId}
        variant="overline"
        color="primary"
        sx={{ fontWeight: "bold", letterSpacing: 1, mb: 2, display: "block" }}
      >
        {label}
      </Typography>
      {children}
    </Paper>
  );
};

interface Props {
  readonly leftLabel: string;
  readonly rightLabel: string;
  readonly left: ReactNode;
  readonly right: ReactNode;
}

/** Split-screen layout: two independent report panes side by side on wide screens, stacked below `lg`. */
const ComparisonPanes: FC<Props> = ({ leftLabel, rightLabel, left, right }) => (
  <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", lg: "1fr 1fr" }, gap: 3, alignItems: "start" }}>
    <Pane label={leftLabel}>{left}</Pane>
    <Pane label={rightLabel}>{right}</Pane>
  </Box>
);

export default ComparisonPanes;
